function isComputed(value) {
  return !!(value && value.__isComputed === true);
}
export {
  isComputed
};
//# sourceMappingURL=isComputed.mjs.map
